<template>
    <a-modal
        title="修改手机"
        :visible="visible"
        class="modal-initialize"
        width="508px"
        @cancel="cancelFun"
        @ok="okFun"
    >
        <div class="bomb-remind">
            <div class="bomb-form">
                <a-form class="inline-form" :form="form">
                    <a-form-item
                        label="手机"
                        v-bind="formItemLayout"
                        labelAlign="left"
                        required
                    >
                        <a-input
                            style="width: 100%"
                            placeholder="请输入手机"
                            v-decorator="['mobile',{rules: [{ required: true, validator: requiredMobile, message: '请输入合法手机' }]} ]"
                        />
                    </a-form-item>
                </a-form>
            </div>
        </div>
    </a-modal>
</template>

<script>

export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        aid: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            form: this.$form.createForm(this),
            formItemLayout: {
                labelCol: {
                    span: 6
                },
                wrapperCol: {
                    span: 18
                },
            },
            dateFormat: 'YYYY-MM',
        };
    },
    watch: {
        // 实现双向绑定
        visible(val) {
            if (val === false) {
                this.form.resetFields(); // 重置表单
            } else {
                this.getData();
            }
        },
    },
    model: {
        prop: 'visible',
        // 这个事件名可以随意写，它实际上是规定了子组件要更新父组件值需要注册的方法
        event: 'changeVisible'
    },
    methods: {
        closeModal() {
            this.$emit('changeVisible', false);
        },
        getData() {

        },
        okFun() {
            this.form.validateFields(
                (errors, values) => {
                    if (!errors) {

                        let url = '/manage/user/mobile';
                        values.aid = this.aid;

                        this.http(url, values, (res) => {
                            this.toast({content: '操作成功'});
                            this.closeModal();
                            this.$emit("confirm");
                        }, null, 1);
                    }
                }
            );
        },
        cancelFun() {
            this.closeModal();
        },
    }
}
</script>